import React, { useState } from "react";
import { Flex, SlideOutDrawer, Text } from "@jsq/ds/core";
import HistoryTable from "./History";
import TransferTabs, { TabOptions } from "./Tabs";
import UnsyncedTableWrapper from "./UnsyncedTable/Wrapper";

type Props = {
  entityName: string;
  selectedEntityId: number;
  arenaId: number;
  isShowing: boolean;
  onClose: () => void;
  onSync: (value: boolean) => void;
};

const TransferSlideout = (props: Props) => {
  const [activeTab, setActiveTab] = useState<TabOptions>(TabOptions.UNSYNCED);
  const [unsyncedCount, setUnsyncedCount] = useState<number>(0);
  return (
    <SlideOutDrawer
      anchor="right"
      drawerSize="fluid"
      shouldCloseOnContentInteraction={false}
      isShowing={props.isShowing}
      headerContent={
        <Text style={{ width: "100%", marginLeft: "-14px" }} variant="regular-xxl">
          {props.entityName} transfers
        </Text>
      }
      onClose={() => {
        setActiveTab(TabOptions.UNSYNCED);
        props.onClose();
      }}
    >
      <TransferTabs
        unsyncedCount={unsyncedCount}
        onClick={(option: React.SetStateAction<TabOptions>) => {
          setActiveTab(option);
        }}
        activeTab={activeTab}
      />
      <Flex
        flexDirection="column"
        style={{
          maxWidth: "948px",
          height: "calc(100vh - 52px)",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: activeTab === TabOptions.UNSYNCED ? "block" : "none",
          }}
        >
          <UnsyncedTableWrapper
            arenaId={props.arenaId}
            selectedEntityId={props.selectedEntityId}
            onSync={() => {
              props.onSync(false);
            }}
            entityName={props.entityName}
            isShowing={props.isShowing}
            onClose={props.onClose}
            onTransferLoaded={(count: number) => {
              setUnsyncedCount(count);
            }}
          />
        </div>
        {activeTab === TabOptions.HISTORY && (
          <div
            style={{
              display: activeTab === TabOptions.HISTORY ? "block" : "none",
            }}
          >
            <HistoryTable
              selectedEntityId={props.selectedEntityId}
              arenaId={props.arenaId}
              onSync={() => {
                props.onSync(true);
              }}
            />
          </div>
        )}
      </Flex>
    </SlideOutDrawer>
  );
};

export default TransferSlideout;
